import React from "react";
import { Box, Typography } from "@material-ui/core";

export interface SuccessBoxProps {
  title?: string;
  text: string;
}
export const SuccessBox: React.FC<SuccessBoxProps> = ({
  title,
  text,
  children,
}) => {
  return (
    <Box
      p={2}
      mt={2}
      mb={2}
      color="#008000"
      style={{ backgroundColor: "#00800055", border: "1px solid #008000" }}
    >
      {title ? <Typography variant="h3">{title}</Typography> : null}
      <Typography>{text}</Typography>
      {children}
    </Box>
  );
};
